import { render } from "./AccessibilityZoom.vue?vue&type=template&id=1bab09b2"
import script from "./AccessibilityZoom.vue?vue&type=script&lang=js"
export * from "./AccessibilityZoom.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francoisgillet/Documents/GitHub/tenjity-module/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__